import React from "react";
import { connect } from 'react-redux';
import { Grid } from "semantic-ui-react";
import { Helmet } from "react-helmet";

// Corrected Helper function to generate the required numeric month values (1st of the month)
const getMonthNumber = (date) => {
    const startDate = new Date(Date.UTC(1899, 11, 30)); // Starting reference date for Excel-like numeric date in UTC
    const diffTime = date.getTime() - startDate.getTime(); // Ensure correct difference
    return Math.floor(diffTime / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
};

// Helper function to get the first day of the month
const getFirstDayOfMonth = (year, month) => {
    return new Date(Date.UTC(year, month, 1)); // Return 1st of the month in UTC
};

const generateQlikLink = () => {
    const currentDate = new Date();
    const firstDayCurrentMonth = getFirstDayOfMonth(currentDate.getUTCFullYear(), currentDate.getUTCMonth());
    const firstDayPreviousMonth = getFirstDayOfMonth(currentDate.getUTCFullYear(), currentDate.getUTCMonth() - 1);

    const previousMonthNum = getMonthNumber(firstDayPreviousMonth);
    const currentMonthNum = getMonthNumber(firstDayCurrentMonth);

    console.log(`Previous Month: ${firstDayPreviousMonth}, Number: ${previousMonthNum}`);
    console.log(`Current Month: ${firstDayCurrentMonth}, Number: ${currentMonthNum}`);



    return `<iframe src="https://qap.inenco.com/insite/single/?appid=ecd67518-c8a7-4361-8c18-7687bf08d8e5&sheet=854efc63-6902-4387-a908-c65c07b4c26c&select=clearall&qlikTicket=iaUr1KhGqhcmdDuv&theme=Inenco_Theme&opt=ctxmenu&select=Month_Name,${previousMonthNum},${currentMonthNum}" style="border:none;max-width:100%!important;width:100%!important;height:1080px!important;"></iframe>`;
};

function Iframe(props) {
    return (
        <div
            dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
        />
    );
}

const QLIKFRAME = props => {
    const iframeSrc = generateQlikLink();

    return (
        <div className='main-container'>
            <Helmet>
                <title>Inenco Portal | Half Hour Data Centre</title>
            </Helmet>
            <Grid padded stackable columns='equal' style={{ height: "100%" }}>
                <Grid.Row>
                    <Grid.Column>
                        <h2>Half Hour Data Centre</h2>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column style={{ height: "1120px", display: "block" }}>
                        <div className="App" style={{ height: '100%', position: 'absolute', left: '0px', width: '100%', overflow: 'auto' }}>
                            <Iframe iframe={iframeSrc} allow="autoplay" style={{ border: 'none', width: '100%!important', height: '1080px!important' }} />
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    );
};

export default connect()(QLIKFRAME);
